module.exports = __webpack_public_path__ + "img/icon_002.3c810854.svg";